import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BPMBtnSetting } from './../../../../model/src/lib/bpm-btn-setting.model';
import { BtnSetting } from './../../../../model/src/lib/btn-setting.model';

// bpm 流程可能使用按鈕設定，包含api回覆的項目、功能頁面自訂按鈕
// title 屬性值用來對應傳入設定之 condition，完全相同者會出現該按鈕
const bpmButtons: BPMBtnSetting[] = [
  {
    title: 'Submit',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.Submit',
    },
  },
  {
    title: 'Approve',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.Submit',
    },
  },
  {
    title: 'ApplyWithdraw',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.Submit',
    },
  },
  {
    title: 'ApproveWithdraw',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.Submit',
    },
  },
  {
    title: 'Release',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.Release',
    },
  },
  {
    title: 'PreviousVersion',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.PreviousVersion',
    },
  },
  {
    title: 'VersionHistory',
    styleClass: 'p-button-primary',
    order: 1,
    state: {
      translateKey: 'SigvLibrary.VersionHistory',
    },
  },
  {
    title: 'Edit',
    styleClass: 'p-button-primary',
    order: 2,
    state: {
      translateKey: 'SigvLibrary.Edit',
    },
  },
  {
    title: 'Save',
    styleClass: 'p-button-primary',
    order: 3,
    state: {
      translateKey: 'SigvLibrary.Save',
    },
  },
  {
    title: 'Cancel',
    styleClass: 'p-button-secondary',
    order: 4,
    state: {
      translateKey: 'SigvLibrary.Cancel',
    },
  },
  {
    title: 'Delete',
    styleClass: 'p-button-secondary',
    order: 4,
    state: {
      translateKey: 'SigvLibrary.Cancel',
    },
  },
  {
    title: 'Return',
    styleClass: 'p-button-secondary',
    order: 5,
    state: {
      translateKey: 'SigvLibrary.Return',
    },
  },
  {
    title: 'RejectWithdraw',
    styleClass: 'p-button-secondary',
    order: 5,
    state: {
      translateKey: 'SigvLibrary.Reject',
    },
  },
  {
    title: 'Copy',
    styleClass: 'p-button-secondary',
    order: 5,
    state: {
      translateKey: 'SigvLibrary.Copy',
    },
  },
  {
    title: 'Reject',
    styleClass: 'p-button-secondary',
    order: 6,
    state: {
      translateKey: 'SigvLibrary.Reject',
    },
  },
  {
    title: 'Print',
    styleClass: 'p-button-outlined',
    order: 7,
    state: {
      translateKey: 'SigvLibrary.Print',
    },
  },
  {
    title: 'Export',
    styleClass: 'p-button-outlined',
    order: 8,
    state: {
      translateKey: 'SigvLibrary.Export',
    },
  },
  {
    title: 'Attachment',
    styleClass: 'p-button-outlined',
    order: 9,
    state: {
      translateKey: 'SigvLibrary.Attachment',
    },
  },
  {
    title: 'ProcessLog',
    styleClass: 'p-button-outlined',
    order: 10,
  },
  {
    title: 'PreviousSetting',
    styleClass: 'p-button-outlined',
    order: 11,
    state: {
      translateKey: 'SigvLibrary.PreviousSetting',
    },
  },
  {
    title: 'Create',
    styleClass: 'p-button-primary',
    order: 12,
    state: {
      translateKey: 'SigvLibrary.Create',
    },
  },
  {
    title: 'Search',
    styleClass: 'p-button-primary',
    order: 13,
    state: {
      translateKey: 'SigvLibrary.Search',
    },
  },
  {
    title: 'Clear',
    styleClass: 'p-button-secondary',
    order: 14,
    state: {
      translateKey: 'SigvLibrary.Clear',
    },
  },
  {
    title: 'InsuredHistory',
    styleClass: 'p-button-outlined',
    order: 15,
    state: {
      translateKey: 'SigvLibrary.InsuredHistory',
    },
  },
  {
    title: 'Back',
    styleClass: 'p-button-outlined',
    order: 16,
    state: {
      translateKey: 'SigvLibrary.Back',
    },
  },
];

// 屬於 bpm 主要流程功能按鈕對應 condition 值
// 與下列值相同之按鈕不需收合於 split(more) button 中
const bpmFunctionButtons: string[] = [
  // submit
  'Submit',
  'Approve',
  'ApplyWithdraw',
  'ApproveWithdraw',
  // edit
  'Edit',
  // save
  'Save',
  // cancel
  'Cancel',
  'Delete',
  // return
  'Return',
  'RejectWithdraw',
  // reject
  'Reject',
  // show/hide tracking records
  'ProcessLog',
  // back
  'Back',
];

/**
 * @description 依據資料設定顯示 bpm 功能相關的按鈕，並且可自訂按鈕執行的方法
 *
 * Sample:
 *
 * <sigv-bpm-btn
 *
 * [setting]="buttons"
 *
 * [maximum]="3"
 *
 * (buttonClick)="bpmButtonClickHandler($event)"></sigv-bpm-btn>
 */
@Component({
  selector: 'sigv-bpm-btn',
  templateUrl: './bpm-btn.component.html',
  styleUrls: ['./bpm-btn.component.scss'],
})
export class BPMBtnComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * @description 要顯示的按鈕設定，有定義於私有變數 bpmButtons 設定中才會出現，出現條件為 condition 與 bpmButtons 的 title 相同
   */
  @Input() setting: BtnSetting[] = [];

  /**
   * @description 客製化按鈕設定，key 需與 bpmButtons 的 title 相同
   */
  @Input() customSetting: {
    [key: string]: MenuItem;
  } = {};
  /**
   * @description 單一按鈕出現最大數量設定，超出設定按鈕依據公版規則置入 split button 內。預設值為 6
   */
  @Input() maximum = 6;
  /**
   * @description 是否顯示 process log 功能按鈕。預設值為 false
   */
  @Input() isShowProcessLog = false;
  /**
   * @description 按鈕 click 事件，提供 native event 與對應 condition 值，使用此組件可自行決定對應的 condition 要執行特定的方法
   */
  @Output() buttonClick: EventEmitter<{ event: any; condition: string }> =
    new EventEmitter<{ event: any; condition: string }>();

  buttons: MenuItem[] = [];
  moreButtons: MenuItem[] = [];

  private readonly destroy$ = new Subject();

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        // 語系切換時，更新 split button 項目顯示的 label
        this.moreButtons.forEach((item) => {
          item.label = item.state?.translateKey
            ? this.translateService.instant(item.state.translateKey)
            : '';
        });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.setting || changes.customSetting) {
      this.bindBtnSetting();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  buttonClickHandler(event: any, condition = ''): void {
    this.buttonClick.emit({
      event,
      condition,
    });
  }

  private bindBtnSetting(): void {
    this.buttons = [];
    this.moreButtons = [];

    const functionButtons = bpmButtons
      .filter(
        (item) =>
          item.title && this.setting.some((s) => s.condition === item.title)
      )
      .map((item) => ({
        ...item,
        ...this.customSetting[item.title ?? ''],
      }))
      .sort((a, b) => a.order - b.order);

    const notProcessFunctionButtons = functionButtons
      .filter(
        (button) => button.title && !bpmFunctionButtons.includes(button.title)
      )
      .sort((a, b) => a.order - b.order);

    if (
      functionButtons.length > this.maximum &&
      notProcessFunctionButtons &&
      notProcessFunctionButtons.length > 1
    ) {
      this.buttons = functionButtons.filter((button) => {
        return notProcessFunctionButtons.every(
          (notProcessFunctionButton) =>
            notProcessFunctionButton.title &&
            button.title &&
            notProcessFunctionButton.title !== button.title
        );
      });
      this.moreButtons = notProcessFunctionButtons.map((button) => {
        return {
          ...button,
          command: (event) => this.buttonClickHandler(event, button.title),
          label: button.state?.translateKey
            ? this.translateService.instant(button.state.translateKey)
            : '',
        };
      });
    } else {
      this.buttons = [...functionButtons];
    }
  }
}
